import { z } from "zod";
import { useAppForm } from "@/shared/forms/app-form";
import type { ExamDefinitionDocument } from "./exam-document";

export const examDefinitionDocumentSchema = z.object({
  examNoteLabel: z.string().min(1).optional(),
  sections: z
    .array(
      z.object({
        id: z.string().optional(),
        label: z.string().min(1, "Section label is required"),
        findings: z
          .array(
            z.object({
              key: z.string(),
              finding: z.string().url("Pick a finding from the registry"),
              prerequisite: z.string().url().optional(),
              // Display facts. Validated loosely because Save drops them.
              label: z.string().optional(),
              optionLabels: z.array(z.string()).optional(),
              componentLabels: z.array(z.string()).optional(),
              resolved: z.boolean().optional(),
            }),
          )
          .min(1, "At least one finding is required"),
      }),
    )
    .min(1, "At least one section is required"),
});

export function useExamDefinitionForm(defaultValues: ExamDefinitionDocument) {
  return useAppForm({
    defaultValues,
    validators: { onDynamic: examDefinitionDocumentSchema },
    onSubmit: () => {},
  });
}

export type ExamDefinitionForm = ReturnType<typeof useExamDefinitionForm>;
